import {Button, Form, Mentions, Select, Switch} from 'antd'
import React, {useCallback, useMemo} from 'react'
import {getFiles} from '../../../../services/assistant'
import {InputSearch} from '../../../input-search'
import {EnterOutlined, MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";


export default function SendText({fieldName, parameters}) {
  const availableVariables = useMemo(
    () =>
      parameters?.properties
        ?.map(({name}) => ({label: name, value: name})),
    [parameters]
  )

  return (
    <>
      <Form.List name={[fieldName, 'action', 'data', 'texts']}>
        {(fields, {add, remove}) => (
          <div style={{overflowY: 'auto'}}>
            {fields.map(({key, name, ...restField}) => (
              <div
                key={key}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginBottom: 8
                }}
              >
                <Form.Item
                  {...restField}
                  name={[name]}
                  rules={[{required: true, message: 'Deve conter uma mensagem'}]}
                  style={{flex: 1, marginBottom: 0}}
                >
                  <Mentions
                    options={availableVariables}
                    prefix={'$'}
                    placeholder="Mensagem"
                    style={{height: '32px'}}
                  />
                </Form.Item>
                <MinusCircleOutlined
                  onClick={() => remove(name)}
                  style={{fontSize: '20px', marginLeft: 8}}
                />
              </div>
            ))}
            <Form.Item>
              <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                Adicionar mensagem
              </Button>
            </Form.Item>
          </div>
        )}
      </Form.List>
    </>
  )
}
